import { transformBrowseResponse, transformSearchResponse } from '../../utils/transformers';
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["STALE"] = "stale";
    RequestStatus["FETCHING"] = "fetching";
    RequestStatus["SUCCESS"] = "success";
    RequestStatus["ERROR"] = "error";
})(RequestStatus || (RequestStatus = {}));
export var RequestType;
(function (RequestType) {
    RequestType["SEARCH"] = "search";
    RequestType["BROWSE"] = "browse";
})(RequestType || (RequestType = {}));
export const initialState = {
    status: RequestStatus.STALE,
    search: null,
    browse: null,
};
export function requestReducer(state, action) {
    switch (action.type) {
        case RequestStatus.FETCHING: {
            return {
                ...state,
                status: RequestStatus.FETCHING,
            };
        }
        case RequestStatus.SUCCESS: {
            const { payload, requestType } = action;
            let search = null;
            let browse = null;
            if (payload) {
                if (requestType === RequestType.SEARCH) {
                    search = transformSearchResponse(payload.rawApiResponse);
                }
                else if (requestType === RequestType.BROWSE) {
                    browse = transformBrowseResponse(payload.rawApiResponse);
                }
            }
            return {
                ...state,
                status: RequestStatus.SUCCESS,
                search,
                browse,
            };
        }
        case RequestStatus.ERROR: {
            return {
                ...state,
                status: RequestStatus.ERROR,
                message: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
export function initFunction(defaultState, initialSearchResponse, initialBrowseResponse) {
    if (initialSearchResponse) {
        return {
            status: RequestStatus.STALE,
            search: transformSearchResponse(initialSearchResponse),
            browse: null,
        };
    }
    if (initialBrowseResponse) {
        return {
            status: RequestStatus.STALE,
            search: null,
            browse: transformBrowseResponse(initialBrowseResponse),
        };
    }
    return defaultState;
}
